import { createContext } from "react"

const OpenningManagementContext = createContext();

export default OpenningManagementContext;